/**
 * QL-399 — the readable name of a flow instance's stage, in one place.
 *
 * Every surface that shows a flow's status shows the same words: the flow
 * page header, and the client's Flows list. Before this there was a map per
 * surface, and they had drifted apart — the Flows list rendered "draft" and
 * "compliance review" in lower case while the flow page said "Draft" and
 * "Compliance review".
 *
 * Two related maps are deliberately NOT folded in here:
 *
 *   - the process stepper abbreviates on purpose ("PDF", "Compliance") because
 *     it is a compact horizontal strip, not a label;
 *   - the client-facing public flow header has its own copy, because its
 *     wording is client-facing copy rather than internal stage names.
 */
export const T = {
  en_GB: {
    draft: "Draft",
    in_progress: "In progress",
    submitted: "Submitted",
    pdf_generated: "PDFs generated",
    compliance_review: "Compliance review",
    external_review: "External review",
    signing: "Signing",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  nb_NO: {
    draft: "Utkast",
    in_progress: "Under arbeid",
    submitted: "Sendt inn",
    pdf_generated: "PDF-er generert",
    compliance_review: "Compliance-gjennomgang",
    external_review: "Ekstern gjennomgang",
    signing: "Signering",
    completed: "Fullført",
    cancelled: "Kansellert",
  },
} as const;
